import state from '@/core/store/ata/pesquisa/adesao/state'
import mutations from '@/core/store/ata/pesquisa/adesao/mutations'

export default {
	state,
	mutations,
}
